import { Button, Modal, Form, Row, Col, message, Input } from "antd";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleAcceptRequest } from "../../../../api/requests";
import formatMoney from "../../../../utils/formatMoney";

export default function RemarksRequest({
  isVisible,
  setVisible,
  request,
  id,
  type,
  selected,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleAcceptRequest,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      setVisible(false);
      queryClient.invalidateQueries({ queryKey: ["requests", id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { remarks } = await form.getFieldsValue();
    const data = { isApproved: false, approverId: selected?._id, remarks, type };
    await mutate({ _id: request?._id, data });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Add Remarks"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="remarkRequest"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="remarkRequest"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div>
          <div className="">
            Add Remarks to the request for
            <span className="font-bold mx-1">Credit Limit</span>
          </div>
          <div className="font-bold text-blue-600 text-center">
            {formatMoney(request?.requestedLimit)} /= TZS
          </div>
        </div>

        <div className="mb-6">
          To Customer :{" "}
          <span className="font-bold">{request?.customerName}</span>
        </div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="remarks"
              label="Remarks"
              rules={[
                {
                  required: true,
                  message: `Please enter remarks`,
                },
              ]}
            >
              <Input placeholder="Remarks" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
